export const DAY_OF_THE_MONTH = 23;

export const WINDOWS = {
  BILLING_DAY: "on",
  OUTSIDE: "outside",
  POST_BILLING: "post",
  PRE_BILLING: "pre",
};
